//
//
//
//
//

import { xtLoginJsPath } from '@/config/project-config'
export default {
  name: "tologin",
  data() {
    return {
      xtLoginJsPath,
      code: this.$route.query.code, // 临时票据
      redirect_uri:this.$route.query.redirect_uri?encodeURI(this.$route.query.redirect_uri):'/',//页面跳转地址
      state: this.$route.query.state,
      msg: '页面跳转中...',
    };
  },
  activated() {
    // const token1 = this.getToken()
    // if (this.getSession() != null) {
    //   const token2 = this.getSession().token
    //   if (token1 && token2 && token1 == token2) {
    //     var query = this.state!=null?{state:JSON.stringify(this.state)}:{}
    //     this.$router.push({path:this.redirect_uri,query})
    //   }
    // }
  },
  methods: {
    tologin() {
      // const token1 = this.getToken()
      // if (this.getSession() != null) {
      //   const token2 = this.getSession().token
      //   if (token1 && token2 && token1 == token2) {
      //     return
      //   }
      // }
      if(!this.code){
        this.msg = '登录跳转失败CODE不能为空'
      }
      // 重新获取token信息
      var that = this
      console.log('-------------tologin---------------')
      if(typeof XtLoginToken === "undefined"){
        this.linkNum+=1
        this.msg=`XtLoginToken未定义，请检查配置信息是否正确(${xtLoginJsPath})`
      }else{
        new XtLoginToken({
          code:this.code,
          successCallBack: function (data) {
            if(data.retCode==1){
                that.$store.commit('setToken',data.obj.token)
                that.$store.commit('setUserInfo',data.obj)
                var query = that.state!=null?{state:JSON.stringify(that.state)}:{}
                that.$router.push({path:that.redirect_uri,query})
            }else{
                that.msg = data.retMsg
                if(that.msg =='token失效，未获取用户信息'){
                  setTimeout(that.$router.push({ path: '/logout' }) ,2000)
                }
            }
          },
          errorCallBack: function (e) {
              that.msg = e
          }
       })
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/login/tologin.vue